module.exports = __webpack_public_path__ + "media/images/faces/male/38-45bb8070815092835afdfe1923984ec6.jpg";